import { Collapse, CollapseProps, Flex } from 'antd';
import { FC, ReactNode } from 'react';
import { Comment } from '../../../ types';
import CommentCard from './CommentCard';

interface IProps {
  expandIcon: (panelProps: any) => ReactNode;
  comments?: Comment[];
}

const CommentsBlock: FC<IProps> = ({ expandIcon, comments }) => {
  const commentsCollapseItems: CollapseProps['items'] = [
    {
      key: '1',
      label: 'КОММЕНТАРИИ',
      children: (
        <Flex vertical gap={10} style={{ paddingTop: '8px' }}>
          {comments
            ?.toSorted((a, b) => (a.createdAt < b.createdAt ? 1 : -1))
            ?.map((comment) => <CommentCard key={comment._id} {...comment} />)}
        </Flex>
      ),
    },
  ];

  return (
    <Collapse
      items={commentsCollapseItems}
      expandIcon={expandIcon}
      expandIconPosition="right"
      bordered={false}
      defaultActiveKey={[1]}
      ghost
    />
  );
};

export default CommentsBlock;
